import { render } from "./PedidoListo.vue?vue&type=template&id=bd534446"
import script from "./PedidoListo.vue?vue&type=script&lang=js"
export * from "./PedidoListo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__